import { parseErrorHelper } from "../../../utils/helpers";
import { UPDATE_LANGUAGE, UPDATE_LOADING, UPDATE_MESSAGE, UPDATE_THEME, SET_MESSAGE } from "../actionTypes";
import { logout } from "./auth";

export const updateTheme = (theme) => {
    localStorage.setItem("theme", theme);
    return {
        type: UPDATE_THEME,
        theme,
    };
};

export const updateMessage = (type, content, data = null) => {
    return {
        type: UPDATE_MESSAGE,
        message: { type, content, data },
    };
};

export const setMessage = (messageType, messageContent, extraData = null) => {
    return {
        type: SET_MESSAGE,
        messageContent,
        messageType: messageType === "error" ? "warning" : messageType, // Map "error" to "warning"
        extraData,
    };
};

export const updateLoading = (loading) => {
    return {
        type: UPDATE_LOADING,
        loading,
    };
};

export const updateLanguage = (language) => {
    return {
        type: UPDATE_LANGUAGE,
        language,
    };
};

export const errorManagementHandler = (e, callback = null) => {
    return (dispatch) => {
        const errorMessage = parseErrorHelper(e);
        dispatch(updateMessage("error", errorMessage));
        if (e.code === "ERR_NETWORK") {
            dispatch(updateMessage("error", "Request timeout"));
            dispatch(logout());
        }
        if (e.response && [401, 469, 470].includes(e.response.status)) {
            dispatch(logout());
        }
        if (callback) callback();
        dispatch(updateLoading(false));
    };
};
